<div class="stepper-container">
  <dx-stepper
    #gpdStepper
    class="gpd-stepper"
    [items]="stepperItems()"
    itemTemplate="stepTemplate"
    [(selectedIndex)]="selectedIndex"
    [width]="stepperWidth()"
  >
    <div *dxTemplate="let item of 'stepTemplate'">
      <div
        class="gpd-step"
        [class.current-step]="item.index == selectedIndex()"
        [class.past-step]="item.index < selectedIndex()"
      >
        <div class="step-icon-outer-container">
          <div class="step-icon-container">
            <app-svg-icon
              [icon]="item.icon"
              [size]="iconSize"
              [strokeWidth]="iconStrokeWidth"
            ></app-svg-icon>
          </div>
        </div>
        <span class="step-title">{{ item.text }}</span>
      </div>
    </div>
  </dx-stepper>
</div>
